/* Slick carousel init removed 2026-09-07 — the USP strip (usp.liquid) and image gallery
   (image-gallery.liquid) now use native CSS scroll-snap instead of the Slick jQuery plugin.
   jQuery + slick.min.js + slick CSS were also removed from layout/theme.liquid, so this file
   is now dependency-free. The quote-form logic below is unchanged. */

/* Email typo guard (added 2026-10-03). A paid quote lead typed "@gmail.xom" and the reply
   bounced. Before a quote form submits (and when the email field loses focus), if the address's
   domain looks like a common misspelling, show a one-tap "Did you mean ...?" fix. It only ever
   interrupts a submit once per address: submitting the same address again goes through.
   Used by both quote forms below: mppEmailGuard.attach(form) + mppEmailGuard.check(form). */
var mppEmailGuard = (function () {
  /* Mistyped endings that are not real TLDs, so they are safe to flag on any domain. */
  var TLD = { con: 'com', cmo: 'com', ocm: 'com', xom: 'com', vom: 'com', cim: 'com', comm: 'com',
              coom: 'com', c0m: 'com', nte: 'net', ent: 'net', ogr: 'org', eud: 'edu' };
  /* Mistyped mailbox providers. */
  var SLD = { gmial: 'gmail', gmai: 'gmail', gmal: 'gmail', gamil: 'gmail', gnail: 'gmail',
              gmaill: 'gmail', gmil: 'gmail', gmali: 'gmail', gmsil: 'gmail', gmaul: 'gmail',
              hotmial: 'hotmail', hotmal: 'hotmail', hotmai: 'hotmail', hotmil: 'hotmail', hotnail: 'hotmail',
              yaho: 'yahoo', yahooo: 'yahoo', yhaoo: 'yahoo', yahho: 'yahoo', yaoo: 'yahoo',
              outlok: 'outlook', outloo: 'outlook', outllok: 'outlook',
              iclod: 'icloud', icoud: 'icloud', icluod: 'icloud', iclould: 'icloud' };
  /* .co / .cm / .om are real country TLDs, so only treat them as ".com" typos on these providers. */
  var BIG = { gmail: 1, hotmail: 1, yahoo: 1, outlook: 1, icloud: 1, aol: 1 };
  var BIGTLD = { co: 'com', cm: 'com', om: 'com' };

  function suggest(email) {
    var m = String(email || '').trim().match(/^([^@\s]+)@([^@\s]+)$/);
    if (!m) return null;
    var domain = m[2].toLowerCase();
    var glued = domain.match(/^(gmail|yahoo|hotmail|outlook|icloud|aol)(com)$/); /* "gmailcom" */
    var parts = glued ? [glued[1], glued[2]] : domain.split('.');
    if (parts.length < 2) return null;
    var last = parts.length - 1;
    if (TLD[parts[last]]) parts[last] = TLD[parts[last]];
    if (parts.length === 2) {
      if (SLD[parts[0]]) parts[0] = SLD[parts[0]];
      if (BIG[parts[0]] && BIGTLD[parts[1]]) parts[1] = BIGTLD[parts[1]];
    }
    var fixed = parts.join('.');
    return fixed === domain ? null : m[1] + '@' + fixed;
  }

  function css() {
    if (document.getElementById('mpq-emailfix-css')) return;
    var s = document.createElement('style');
    s.id = 'mpq-emailfix-css';
    s.textContent =
      '.mpq-emailfix{flex:1 1 100%;grid-column:1 / -1;width:100%;box-sizing:border-box;margin:0 0 4px;' +
      'padding:9px 12px;font-size:14px;font-weight:500;line-height:1.45;text-align:left;color:#5c4a12;' +
      'background:#fdf6e3;border:1px solid #f0e4bf;border-radius:8px;}' +
      '.mpq-emailfix b{font-weight:700;word-break:break-all;}' +
      '.mpq-emailfix span{display:inline-block;margin-left:-12px;}' +
      /* The choices are links, not <button>s: both quote forms style every button inside them
         as a large CTA (some rules use !important), which a <button> here would inherit. */
      '.mpq-emailfix a{display:inline-block;cursor:pointer;margin:0 0 0 12px;font-weight:700;' +
      'color:#16305c !important;text-decoration:underline !important;white-space:nowrap;}' +
      '.mpq-emailfix a:focus-visible{outline:2px solid #16305c;outline-offset:2px;}' +
      '.mpq-emailfix a.mpq-emailfix__no{font-weight:500;}';
    document.head.appendChild(s);
  }

  function hide(form) {
    var h = form.querySelector('.mpq-emailfix');
    if (h) h.remove();
  }

  /* fromSubmit: the visitor had already pressed the submit button, so either answer re-submits. */
  function show(form, input, fix, fromSubmit) {
    css();
    hide(form);
    var h = document.createElement('p');
    h.className = 'mpq-emailfix';
    h.setAttribute('role', 'alert');
    h.appendChild(document.createTextNode('Did you mean '));
    var b = document.createElement('b');
    b.textContent = fix;
    h.appendChild(b);
    h.appendChild(document.createTextNode('?'));
    function resubmit() {
      if (!fromSubmit) return;
      if (form.requestSubmit) form.requestSubmit();
      else { var sb = form.querySelector('button[type=submit]'); if (sb) sb.click(); }
    }
    var choices = document.createElement('span');
    function choice(label, cls, fn) {
      var a = document.createElement('a');
      a.href = '#';
      a.setAttribute('role', 'button');
      if (cls) a.className = cls;
      a.textContent = label;
      a.addEventListener('click', function (e) { e.preventDefault(); fn(); });
      a.addEventListener('keydown', function (e) { if (e.key === ' ') { e.preventDefault(); fn(); } });
      choices.appendChild(a);
    }
    choice('Yes, fix it', '', function () {
      input.value = fix;
      form.__mppEmailOk = null;
      hide(form);
      resubmit();
    });
    choice("No, it's correct", 'mpq-emailfix__no', function () {
      form.__mppEmailOk = input.value.trim().toLowerCase();
      hide(form);
      resubmit();
    });
    h.appendChild(document.createTextNode(' '));
    h.appendChild(choices);
    (input.closest('label') || input).insertAdjacentElement('afterend', h);
  }

  /* Call from the submit handler. Returns true when it has just shown a suggestion, in which
     case the caller should stop this submit. */
  function check(form) {
    var input = form.querySelector('input[name=email]');
    if (!input) return false;
    var val = input.value.trim();
    var fix = suggest(val);
    if (!fix || form.__mppEmailOk === val.toLowerCase()) { hide(form); return false; }
    form.__mppEmailOk = val.toLowerCase();
    show(form, input, fix, true);
    return true;
  }

  /* Suggest as soon as the visitor leaves the email field (never blocks anything). */
  function attach(form) {
    var input = form.querySelector('input[name=email]');
    if (!input || input.__mppEmailGuard) return;
    input.__mppEmailGuard = true;
    input.addEventListener('change', function () {
      var val = input.value.trim();
      var fix = suggest(val);
      if (fix && form.__mppEmailOk !== val.toLowerCase()) show(form, input, fix, false);
      else hide(form);
    });
  }

  return { suggest: suggest, check: check, attach: attach };
})();

/* "Needed by" date on both quote forms (added 2026-10-16): the date picker starts at today, so a
   day that has already passed can't be picked (reportValidity flags a typed one). Uses the
   visitor's own calendar date. The pipeline app checks the date against the 4 to 5 week lead time. */
function mppNeededByMin(form) {
  var el = form.querySelector('input[name=neededBy]');
  if (!el) return;
  var d = new Date();
  el.min = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
}

/* Match Point native quote form — lives in the theme (not the page's body_html) so a
   Shopify page-editor save can never strip it. The rich-text page editor sanitizes raw
   HTML on save and drops <script> tags and data-* attributes; it does not touch theme
   asset files, so this is immune to that. */
(function () {
  var f = document.getElementById('mpq');
  if (!f) return;
  var err = f.querySelector('.mpq-err');
  var btn = f.querySelector('button[type=submit]');
  var origBtnText = btn.textContent;
  var endpoint = 'https://customer-pipeline-tracking-app.vercel.app/api/quote';
  mppEmailGuard.attach(f);
  mppNeededByMin(f);

  /* Header "Get a Quote" on a page that already has this form (added 2026-10-03). Clarity showed a
     wholesale prospect type into the wholesale page's form, click the header button, land on the
     general quote page with an empty form, and leave. On any page that carries a #mpq form the
     header button now scrolls to that form instead of navigating away, so nothing typed is lost.
     Modified clicks (new tab / new window) keep their normal behavior. */
  document.querySelectorAll('.btn--header--desktop, .btn--header--mobile').forEach(function (cta) {
    cta.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      var target = f.closest('#quote') || f;
      var bar = document.querySelector('.header-wrapper');
      target.style.scrollMarginTop = ((bar ? bar.offsetHeight : 0) + 16) + 'px';
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: calm ? 'auto' : 'smooth', block: 'start' });
      /* With a mouse, put the cursor in the first empty field (touch devices would pop the keyboard). */
      if (window.matchMedia && window.matchMedia('(pointer:fine)').matches) {
        var first = Array.prototype.filter.call(f.querySelectorAll('input[name=name], input[name=email]'), function (el) { return !el.value; })[0];
        if (first) first.focus({ preventScroll: true });
      }
    });
  });

  f.addEventListener('submit', async function (e) {
    e.preventDefault();
    if (!f.reportValidity()) return;
    if (mppEmailGuard.check(f)) return;
    err.hidden = true; btn.disabled = true; btn.textContent = 'Sending…';
    try {
      var res = await fetch(endpoint, { method: 'POST', body: new FormData(f) });
      var data = await res.json();
      if (data && data.ok && data.redirect) { window.location.href = data.redirect; return; }
      throw new Error((data && data.error) || 'Something went wrong');
    } catch (ex) {
      err.textContent = (ex && ex.message) || "Couldn't send — please email info@matchpointpromotions.com";
      err.hidden = false; btn.disabled = false; btn.textContent = origBtnText;
    }
  });
})();

/* Match Point — truncated product-page quote form (snippets/mpq-mini-quote.liquid).
   Same theme-based-JS pattern as the main quote form above: lives here, not in any
   page/product body content, so it's immune to editor sanitization. Handles multiple
   instances defensively even though each product page normally renders just one. */
(function () {
  var endpoint = 'https://customer-pipeline-tracking-app.vercel.app/api/quote';
  /* Shopify product handle → [JotForm "Which product" value, minimum order quantity].
     Values must match the quote form's own <select> options exactly (the Edge
     Protection Tape option really has two spaces). Mirrors the MAP originally built
     for the old redirect-based quick-quote widget this replaces. */
  var MAP = {
    'custom-vibration-dampeners':                ['Tennis Vibration Dampeners', 100],
    'custom-tennis-grip-bands':                   ['Tennis Grip Bands', 100],
    'custom-tennis-overgrips':                    ['Tennis Overgrips', 300],
    'custom-pickleball-grip-bands':                ['Pickleball Grip Bands', 100],
    'custom-pickleball-overgrips':                  ['Pickleball Overgrips', 300],
    'custom-pickleball-eraser':                    ['Pickleball Erasers', 100],
    'custom-pickleball-edge-protection-tape':      ['Pickleball  Edge Protection Tape', 600],
    'custom-pickleball-lead-tape':                  ['Pickleball Lead Tape', 10000],
    'custom-pickleball-bag':                        ['Pickleball Bags', 300],
    'custom-bag-luggage-tags':                      ['Sports Bag Tags', 200],
    'custom-embroidered-terry-cloth-wristbands':    ['Terry Cloth Wristbands', 100],
    'custom-embroidered-terry-cloth-headbands':     ['Terry Cloth Headbands', 100],
    'custom-3d-chrome-car-emblems':                 ['Chrome Emblems', 100],
    'custom-magnets':                               ['Magnets', 100],
    'custom-keychains':                             ['Keychains', 200],
    'custom-bottle-openers':                        ['Bottle Openers', 200],
    'custom-silicone-wristbands':                   ['Silicone Wristbands', 100],
    'custom-padel-overgrips':                       ['Padel Overgrips', 300],
    'custom-badminton-overgrips':                   ['Badminton Overgrips', 300],
    'custom-pickleball-paddle-cap-weights':         ['Pickleball Cap Weights', 300],
    'custom-pickleballs':                           ['Pickleballs', 200],
    'custom-enamel-pins':                           ['Enamel Pins', 100],
    'custom-challenge-coins':                       ['Challenge Coins', 100]
  };

  document.querySelectorAll('.mpq-mini__form').forEach(function (f) {
    var wrap = f.closest('.mpq-mini');
    var handle = wrap ? wrap.getAttribute('data-handle') : null;
    var entry = MAP[handle];
    var moq = entry ? entry[1] : 100;
    var qtyEl = f.querySelector('input[name=quantity]');
    if (qtyEl) qtyEl.placeholder = 'Qty (min ' + moq.toLocaleString() + ')';
    var err = f.querySelector('.mpq-mini__err');
    var btn = f.querySelector('button[type=submit]');
    var originalBtnText = btn.textContent;
    mppEmailGuard.attach(f);
    mppNeededByMin(f);

    f.addEventListener('submit', async function (e) {
      e.preventDefault();
      if (!f.reportValidity()) return;
      if (mppEmailGuard.check(f)) return;
      err.hidden = true; btn.disabled = true; btn.textContent = 'Sending…';
      try {
        var fd = new FormData(f);
        if (entry) fd.set('product', entry[0]);
        /* Material toggle (2026-10-22): pages with a Silicone / Metal price toggle mark the form with
           the material that was showing (sections/mpp-product.liquid). It rides in the existing
           "Any other product details?" field, so the pipeline app and JotForm need no change. */
        var material = wrap ? wrap.getAttribute('data-material') : null;
        if (material) {
          var details = fd.get('additionalDetails');
          fd.set('additionalDetails', 'Material: ' + material + (details ? '\n' + details : ''));
        }
        var q = parseInt(fd.get('quantity'), 10);
        if (!(q > 0)) q = moq;
        if (q < moq) q = moq; /* never submit below the product minimum */
        fd.set('quantity', q);
        var res = await fetch(endpoint, { method: 'POST', body: fd });
        var data = await res.json();
        if (data && data.ok && data.redirect) { window.location.href = data.redirect; return; }
        throw new Error((data && data.error) || 'Something went wrong');
      } catch (ex) {
        err.textContent = (ex && ex.message) || "Couldn't send — please email info@matchpointpromotions.com";
        err.hidden = false; btn.disabled = false; btn.textContent = originalBtnText;
      }
    });
  });
})();
